import React, { useState, useEffect } from 'react'
import { api } from '../../../services/api'

import { UserTable } from './UserTableList/userTable'
import { Forms } from './UserCreation/forms'
import { H2Generator } from '../../functions/H2Generator'
import { ConfirmationModal } from './ConfirmationModal'

import styles from './user.module.scss'

import 'framer-motion'
import { motion, useAnimation } from 'framer-motion'

type UserProps = {

}

type User = {
    ID: number,
    CM_EMAIL: string,
    CM_NOME: string,
    CM_NOME_USUARIO: string,
    CM_ADMIN: string,
}

export function UserAdmin(props: UserProps) {

    const [data, setData] = useState<User[]>([])

    useEffect(() => {
        const fetchData = async () => {
            const result = await api.get('/usuarios')
                .then((resp => resp.data))

            setData(result);
        };

        fetchData();
    }, []);

    function getUser() {
        const fetchData = async () => {
            const result = await api.get('/usuarios')
                .then((resp => resp.data))

            setData(result);
        };

        fetchData();
    }

    const [userData, setUserData] = useState({
        ID: '',
        CM_NOME: '',
        CM_NOME_USUARIO: '',
        CM_EMAIL: '', CM_SENHA: '',
        CM_CONFIRMAR_SENHA: '', CM_ADMIN: false
    })

    const [userDeleteData, setUserDeleteData] = React.useState({
        ID: ''
    })

    const [confirmationMessage, setConfirmationMessage] = React.useState('')
    const [confirmationStatus, setConfirmationStatus] = React.useState(styles.confirmationModalContainerOff)

    function putUser(usuario: any) {
        setConfirmationMessage(`Você tem certeza que deseja editar o usuário "${usuario.CM_NOME}"?`)
        setConfirmationStatus(styles.confirmationModalContainerPencilOff)
        setConfirmationStatus(styles.confirmationModalContainerPencilOn)
        getUser()
        setUserData({
            ID: usuario.ID,
            CM_NOME: usuario.CM_NOME,
            CM_NOME_USUARIO: usuario.CM_NOME_USUARIO,
            CM_EMAIL: usuario.CM_EMAIL, CM_SENHA: '',
            CM_CONFIRMAR_SENHA: '',
            CM_ADMIN: false
        })
    }

    function confirmPutUser() {
        setConfirmationStatus(styles.confirmationModalContainerPencilOff)
        setMotionsForm('userButton')
    }

    function cancelPutUser() {
        setConfirmationStatus(styles.confirmationModalContainerPencilOff)
        setUserData({
            ID: '',
            CM_NOME: '',
            CM_NOME_USUARIO: '',
            CM_EMAIL: '', CM_SENHA: '',
            CM_CONFIRMAR_SENHA: '', CM_ADMIN: false
        })
    }

    function removeUser(usuario: any) {
        setConfirmationMessage(`Você tem certeza que deseja excluir o usuário "${usuario.CM_NOME}"?`)
        setConfirmationStatus(styles.confirmationModalContainerTrashOff)
        setConfirmationStatus(styles.confirmationModalContainerTrashOn)

        setUserDeleteData({
            ID: usuario.ID
        })
    }

    function confirmRemoveUser() {
        setConfirmationStatus(styles.confirmationModalContainerTrashOff)
        api.delete(`/usuarios/${userDeleteData.ID}`)
            .then(() => {
                getUser()
            })
    }

    function cancelRemoveUser() {
        setConfirmationStatus(styles.confirmationModalContainerTrashOff)
        setUserDeleteData({
            ID: ''
        })
    }

    const userButtonAnimation = useAnimation()
    const formsContainerAnimation = useAnimation()

    function setMotionsForm(element: string) {
        if (element === 'userButton') {
            userButtonAnimation.start({
                opacity: 0,
                y: -10
            })

            formsContainerAnimation.start({
                height: '330px',
                marginTop: '-100px'
            })
        }
    }

    function resetMotionsForm(element: string) {
        if (element === 'userButton') {
            userButtonAnimation.start({
                opacity: 1,
                y: 0
            })

            formsContainerAnimation.start({
                height: '0px',
                marginTop: '20px'
            })
        }
    }

    return (
        <div className={styles.allContainer} >
            <ConfirmationModal
                title={confirmationMessage}
                status={confirmationStatus}
                confirm={userData.ID.length === 0 ? confirmRemoveUser : confirmPutUser}
                cancel={userData.ID.length === 0 ? cancelRemoveUser : cancelPutUser}
                iconConfirmation={userData.ID.length === 0 ? 'faTrashAlt' : 'faPencilAlt'} />
            <div className={styles.titleContainer}>
                <H2Generator textos={["Controle de Usuários", "Aqui você pode criar, editar e remover usuários."]} />
            </div>
            <div className={styles.userButtonContainer}>
                <motion.button
                    className={styles.buttonUser}
                    onClick={() => setMotionsForm('userButton')}
                    animate={userButtonAnimation}
                    transition={{ ease: 'easeOut' }}
                    whileTap={{ scale: 0.95 }}>Criar Usuário</motion.button>
            </div>
            <motion.div 
                className={styles.formContainer}
                animate={formsContainerAnimation}
                transition={{duration: 0.3}}>
                <Forms
                    userData={userData}
                    onSubmitData={getUser}
                    changeContainerUser={resetMotionsForm}
                />
            </motion.div>
            <div className={styles.tableContainer}>
                <hr className={styles.hr} />
                <UserTable
                    data={data}
                    putUser={putUser}
                    removeUser={removeUser} />
            </div>
        </div>
    )
}